import axios from "axios";
import {AUTH} from "../auth/FirebaseContext";

export const customAxios = axios.create({
    baseURL: "https://transport-api.e-fiskal.rs:8080",
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: false,
});

customAxios.interceptors.request.use(
    async (config) => {
        const token = await AUTH.currentUser.getIdToken(true);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

customAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            // TODO sacuvati ono sto je korisnik uneo ili koristiti refresh token ??
            // originalRequest._retry = true;
            // const apiData = await getApiData();
            // const response = await axios.post(`${BASE_URL}/auth`, apiData);
            // const newToken = response.data;
            // await saveTokenData(newToken);
            // axiosInstance.defaults.headers.Authorization = `Bearer ${newToken.access_token}`;
            // return axiosInstance(originalRequest);
        }
        return Promise.reject((error.response && error.response.data) || "Something went wrong");
    },
);

// ZA OPERATORS
export async function getAllOperatorsBEApi() {
    return customAxios.get(`/operator?page=0&size=1000`)
}

// ZA AUTOBUSE
export async function getAllBusesApi(params) {
    return customAxios.get(`/composition?${params}`)
}

export async function getBusByIdApi(id) {
    return customAxios.get(`/composition/${id}`)
}

export async function postBusApi(data) {
    return customAxios.post(`/composition`, data)
}

export async function updateBusApi(data) {
    return customAxios.put(`/composition`, data)
}

export async function deleteBusApi(id) {
    return customAxios.delete(`/composition/${id}`)
}

//rate-card-controller (CENOVNIK)
export async function getAllRateCardsApi2(params, searchObject) {
    return customAxios.get(`/rate/rateCard/${searchObject}?${params}`)
}

export async function getAllRateCardsApi() {
    return customAxios.get(`/rateCard?page=0&size=1000`)
}

export async function getRateCardByIdApi(id) {
    return customAxios.get(`/rateCard/${id}`)
}

export async function postRateCardApi(data) {
    return customAxios.post(`/rateCard`, data)
}

export async function updateRateCardApi(data) {
    return customAxios.put(`/rateCard`, data)
}

export async function deleteRateCardApi(id) {
    return customAxios.delete(`/rateCard/${id}`)
}

//rate-controller ()
export async function getAllRatesApi(params) {
    return customAxios.get(`/rate?${params}`)
}

export async function getRateByIdApi(id) {
    return customAxios.get(`/rate/${id}`)
}

export async function postRateApi(data) {
    return customAxios.post(`/rate`, data)
}

export async function postRateSearchApi(data, params) {
    return customAxios.post(`/rate/search?${params}`, data)
}

export async function updateRateApi(data) {
    return customAxios.put(`/rate`, data)
}

export async function deleteRateApi(id) {
    return customAxios.delete(`/rate/${id}`)
}

// export async function getAllRatesCardByIdApi(id) {
//     return customAxios.get(`/rate/rateCard/${id}?size=2000`)
// }

export async function getAllRatesCardByIdApi(id, page = 0, allRates = []) {
    const pageSize = 2000;
    const response = await customAxios.get(`/rate/rateCard/${id}?size=${pageSize}&page=${page}`);

    allRates.push(...response?.data?.content);

    if (response.data.numberOfElements !== 2000) {
        return allRates;
    }

    return getAllRatesCardByIdApi(id, page + 1, allRates);
}
export async function getAllRatesCardByIdApiWithPagination(id, page = 0, pageSize = 2000) {
    const response = await customAxios.get(`/rate/rateCard/${id}?page=${page}&size=${pageSize}`);
    const data = response.data;
    // Check if there are more results to fetch
    if (data.content.length === pageSize) {
        // Fetch the next page of results
        const nextPageData = await getAllRatesCardByIdApiWithPagination(id, page + 1, pageSize);
        data.content = data.content.concat(nextPageData.content);
    }
    return data;
}
// STATIONS
export async function getStationDepartureDepIdApi(depId) {
    return customAxios.get(`station/arrival/${depId}`)
}

// TRIP

export async function getDepAndArrStationsApi(data) {
    return customAxios.post(`/trip/depAndArrStations`, data)
}

// lineStation

export async function updateLineStationApi(data) {
    return await customAxios.put(`/lineStation`, data)
}

export async function getLineStationsByLineIdApi(lineId) {
    return await customAxios.get(`/lineStation/line/${lineId}?size=1999&sort=tripTime,asc`)
}

export async function getAllLineStations() {
    return await customAxios.get(`/lineStation?size=2000`)
}

export async function insertLineStationApi(payload) {
    return await customAxios.post("/lineStation", payload)
}


//LOCATIONS
export async function getAllLocationsApi() {
    return customAxios.get(`/location?size=2000`)
}

export async function putLocationApi(data) {
    return customAxios.put(`/location`, data)
}

export async function postLocationApi(data) {
    return customAxios.post(`/location`, data)
}

export async function getLocationByIdApi(id) {
    return customAxios.get(`/location/${id}`)
}

export async function deleteLocationByIdApi(id) {
    return customAxios.delete(`/location/${id}`)
}

//country-controller (DRZAVE)
export async function getAllCountriesApi() {
    return customAxios.get(`/country?size=2000`)
}

export async function putCountryApi(data) {
    return customAxios.put(`/country`, data)
}

export async function postCountryApi(data) {
    return customAxios.post(`/country`, data)
}

export async function getCountryByIdApi(id) {
    return customAxios.get(`/country/${id}`)
}

export async function deleteCountryByIdApi(id) {
    return customAxios.delete(`/country/${id}`)
}

// LINIJE
export async function getAllLines(payload) {
    return payload ?
        customAxios.get(`/line?page=${payload.page}&size=${payload.rowsPerPage}`) :
        customAxios.get(`/line?size=2000`)
}

export async function getAllLinesPaginationAPI(page = 0, pageSize = 2000) {
    const response = await customAxios.get(`/line/page=${page}&size=${pageSize}`);
    const data = response.data;
    if(data.content.length === pageSize){
        const nextPageData = await getAllLinesPaginationAPI(page+1, pageSize);
        data.content = data.content.concat(nextPageData.content);
    }
    return data;
}

export async function getLineByFilterApi(payload){
    return  customAxios.post(`/line/search?page=${payload.page}&size=${payload.rowsPerPage}`, payload.data)
}

export async function getLineByIdApi(id) {
    return customAxios.get(`/line/${id}`)
}

export async function activateLineByIdApi(payload) {
    return customAxios.post(`/line/${payload.id}/activate`, payload)
}

export async function insertLineApi(data) {
    return await customAxios.post(`/line`, data).catch(function (error) {
        if (error.response) {
            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
        } else if (error.request) {
            console.error(error.request);
        } else {
            console.error('Error', error.message);
        }
        console.error(error.config);
    });
}

export async function setLineActiveApi(id) {
    return customAxios.post(`/line/${id}/activate`)
}

// TODO OVO VRACA 200 al nikad ne obrise...problem be
export async function deleteLineByIdApi(id) {
    return customAxios.delete(`/line/${id}`)
}

export async function updateLineByIdApi(data) {
    return customAxios.put(`/line`, data)
}
// line-station-departure-arrival-controller
export async function searchLineStationDepartureArrivalApi(data, params) {
    return customAxios.post(`/lineStationDepartureArrival/search?${params}`, data)
}

export async function fetchLineStationDepartureArrivalApi() {
    return customAxios.get(`/lineStationDepartureArrival?page=0&size=10`)
}

// TICKET
export async function postTicketReservedSeatsApi(data) {
    return customAxios.post(`/ticket/freeSeats`, data)
}

export async function postTicketAPi(data) {
    return customAxios.post(`/ticket`, data)
}

// TICKET TYPE (POPUSTI)

export async function getAllDiscountsApi() {
    return customAxios.get(`/api/ticketType?page=0&size=2000`)
}

export async function postDiscountApi(data) {
    return customAxios.post(`/api/ticketType`, data)
}

export async function updateDiscountApi(data) {
    return customAxios.put(`/api/ticketType`, data)
}

export async function deleteDiscountApi(id) {
    return customAxios.delete(`/api/ticketType/${id}`)
}

// OPERATION INTERVAL
export async function getAllOperationIntervalApi() {
    return customAxios.get(`/operationalInterval`)
}

// TRIP
export async function getAllTripsByOperatorApi(){
    return customAxios.get(`/trip/byOperator?page=0&size=2000`)
}

export async function getAllTripTimesByOperatorApi(){
    return customAxios.get(`/trip/times`)
}

export async function getAllTripApi() {
    return customAxios.get(`/trip?page=0&size=2000`)
}

export async function putTripApi(data) {
    return customAxios.put(`/trip`, data)
}

export async function postTripApi(data) {
    return customAxios.post(`/trip`, data)
}

export async function getTripByIdApi(id) {
    return customAxios.get(`/trip/${id}`)
}

export async function deleteTripByIdApi(id) {
    return customAxios.delete(`/trip/${id}`)
}

// RFID CARD
export async function getRFIDCardApi() {
    return customAxios.get(`rfidCard?page=0&size=2000`)
}

export async function postRFIDCardApi(data) {
    return customAxios.post('rfidCard', data)
}

export async function extendRFIDCardApi(data) {
    return customAxios.post('rfidCard/extend', data)
}

export async function deleteRFIDCardApi(data) {
    return customAxios.delete(`rfidCard/${data.cardNumber}`, data)
}
// TRIP DETAILS
export async function findTripDetail(data) {
    return customAxios.post(`/tripDetails/search`, {
        lineId: data.lineId,
        operationalIntervalId: data.operationalIntervalId,
        arrivalStationId: data.arrivalStationId,
        departureStationId: data.departureStationId,
        rateCardId: data.rateCardId
    })
}

// REGION
export async function fetchAllRegionsApi() {
    return customAxios.get(`/region`)
}

export async function insertRegionApi(data) {
    return customAxios.post(`/region/`, data)
}

// STATIONS
export async function searchStationApi(payload) {
    return  customAxios.post(`/station/search?page=${payload.page}&size=${payload.rowsPerPage}`, payload.data)
}

export async function getStationByIDAPI(id) {
    return customAxios.get(`/station/${id}`)
}

// TODO logiku dodati za vise od 2k
export async function getStationApi() {
    return customAxios.get(`/station?page=0&size=2000`);
}

export async function insertStationApi(data) {
    return customAxios.post(`/station`, data);
}

export async function updateStationApi(data) {
    return customAxios.post(`/station`, data);
}

export async function deleteStationApi(id) {
    return customAxios.delete(`/station/${id}`);
}

// CARRIERS

// TODO ceka se be


// ----------------------
export const search = async (value, cancelToken) => {
    let response
    await customAxios
        .post('/station/departure/search', {stationName: value}, {
            cancelToken
        })
        .then((r) => {
            response = r.data.content
        })
        .catch(error => {
            console.error('usao u err')
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

export const searchStationName = async (value, cancelToken) => {
    let response
    const config = {
        cancelToken
    };
    await customAxios
        .post('/station/search', {stationName: value}, config)
        .then((r) => {
            response = r.data.content
        })
        .catch(error => {
            console.error('usao u err')
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}

